export const coinRain = (count = 36) => {
  if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
  const layer = document.createElement("div");
  layer.className = "coin-rain-layer";
  layer.setAttribute("data-testid", "coin-rain");
  for (let i = 0; i < count; i++) {
    const c = document.createElement("img");
    c.src = "/mela/coin.png";
    c.alt = "";
    c.className = "coin-rain-coin";
    const s = 18 + Math.random() * 28;
    c.style.width = `${s}px`;
    c.style.left = `${Math.random() * 100}%`;
    c.style.animationDelay = `${Math.random() * 1}s`;
    c.style.animationDuration = `${1.5 + Math.random() * 1.5}s`;
    c.style.setProperty("--spin", `${(Math.random() > 0.5 ? 1 : -1) * (360 + Math.random() * 540)}deg`);
    c.style.setProperty("--drift", `${(Math.random() - 0.5) * 140}px`);
    layer.appendChild(c);
  }
  document.body.appendChild(layer);
  setTimeout(() => layer.remove(), 4500);
};
